import assetUtils, { Asset } from 'app-lib/assetUtils'
import { formatPercent, formatPrecision } from 'bzx-common/src/lib/numberUtils'
import PriceSwitch from 'bzx-common/src/shared-components/PriceSwitch'
import React, { useEffect, useState } from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { InfoTip } from 'ui-framework'
import { BigNumber } from '@0x/utils'
import { ChainId, links } from '../../config/appConfig'

export interface IExpectedResultProps {
  collaterizationPercents: BigNumber
  liquidationPrice: BigNumber
  collateralToken: Asset
  loanToken: Asset
  loanStatus: string
  chainId: ChainId
}

function ExpectedResult(props: IExpectedResultProps) {
  const { chainId } = props

  const [activeTokenLiquidation, setActiveTokenLiquidation] = useState(
    assetUtils.getDefaultActiveToken(chainId, props.loanToken, props.collateralToken)
  )

  useEffect(() => {
    // sbp - need to take this piece out with borrow more form, otherwise liq price doesn't load
    // if other forms break need to revaluate
    // setLiquidationPriceLoaded(false)
    setActiveTokenLiquidation(
      assetUtils.getDefaultActiveToken(chainId, props.loanToken, props.collateralToken)
    )
  }, [chainId, props.collateralToken])

  const liquidationPrice =
    activeTokenLiquidation === props.collateralToken
      ? props.liquidationPrice
      : new BigNumber(1).div(props.liquidationPrice)

  const liquidationPriceText =
    !liquidationPrice.isNaN() && liquidationPrice.isFinite()
      ? formatPrecision(liquidationPrice)
      : '-'

  const collaterizationPercents = props.collaterizationPercents.isNaN()
    ? '-'
    : formatPercent(props.collaterizationPercents) + '%'
  return (
    <div className="grid-2-col margin-bottom-1">
      <div className="panel--simple padded-1">
        <div className="txt-muted txt-subtitle">
          Collateralized{' '}
          <InfoTip id="collateral-percent-tip">
            Each asset pairing has unique collateral requirements for position maintenance.{' '}
            <ExternalLink href={links.loanCollateralTable} className="link--discreet">
              Learn More
            </ExternalLink>
            .
          </InfoTip>
        </div>
        <div className={`txt-title expected-result__collateral-value ${props.loanStatus}`}>
          {collaterizationPercents}
        </div>
      </div>
      <div className="panel--simple padded-1">
        <div className="txt-muted txt-subtitle">Liq. Price</div>
        <PriceSwitch
          selectedAsset={activeTokenLiquidation}
          onAssetChange={(asset) => setActiveTokenLiquidation(asset)}
          loanAsset={props.loanToken}
          collateralAsset={props.collateralToken}
          textTooltip="Liq is the price at which your position is liquidated."
        />

        <div title={`${liquidationPrice.toFixed(18)}`} className="expected-result__column-value">
          <div>
            <span className="value">{liquidationPriceText}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default React.memo(ExpectedResult)
